// extracted by mini-css-extract-plugin
module.exports = {"icon":"_69ChP","iconWrapper":"_1wqb_"};